const setting = {
  passwordTitle: "密碼",
  changePasswordBtn: "更換密碼",
  changePasswordTips:
    "如果您忘記密碼或者想要更換密碼，您可以在此處進行操作；我們向您的註冊郵箱發送驗證碼，郵箱經過驗證，確定您的身份後，您可以重新設置帳戶密碼；",
  feedbackTitle: "反饋",
  feedbackBtn: "提交反饋",
  feedbackTips: "為了讓我們更好的為您提供服務，您可以在此處描述您的問題並提交，向我們反饋，我們的客服人員會儘快與您聯繫。",
  appearanceTitle: "外觀顯示",
  appearanceBtn: "更改顯示",
  appearanceTips: "我們為您選擇兩種外觀模式，您可以根據自己的喜好去切換深色模式還是淺色模式；",
  changePassWordModalTitle: "更換密碼",
  changePassWordSameErrorTips: "輸入新密碼與舊密碼一致，請輸入不同的密碼",
  changePasswordCurrentErrorTips: "密碼不正確，請再試一遍",
  currentPasswordLabel: "當前密碼",
  newPasswordLabel: "新密碼",
  retypePasswordLabel: "再次輸入新密碼",
  changePasswordSuccessTips: "你的密碼已成功重置",
  changePasswordComfirmDiffErrorTips: "請兩次輸入相同的密碼",
  forgotPassword: "忘記密碼了？",
  feedbackModalSubtitle: "感謝您聯繫我們並告訴我們您對產品的意見",
  feedBackModalProductQuestion: "使用此產品想要解決什麼樣的問題？",
  feedBackModalProductTypeSug: "意見建議",
  feedBackModalProductTypeMem: "會員服務相關問題",
  feedBackModalProductTypeFun: "功能詢問",
  feedBackModalProductTypeReq: "產品需求",
  feedBackModalProductTypeBug: "產品bug反饋",
  feedBackModalProductTypeIss: "性能問題",
  feedBackModalProductTypeRL: "註冊登錄相關問題",
  feedBackModalProductTypeRef: "退款服務",
  feedBackModalProductTypeOth: "其他",
  feedBackModalProductSelectQuestion: "使用此產品想要解決什麼樣的問題？",
  feedBackModalProductContQuestion: "使用產品時您遇到了什麼問題？",
  feedBackModalAddImageBtn: "添加圖片",
  feedBackModalTips: "提示：",
  feedBackModalTipsCont: "由於全球客服的時差問題，我們將會在工作日的48小時內回復您；",
  feedBackSuccessTips: "發送成功",
  feedBackSuccessSubTips: "我們會儘快解決你的問題",
  feedBackFailedTips: "發送失敗",
  feedBackFailedSubTips: "請確保網路連接正常，然後重新提交",
  appearanceLightMode: "淺色模式",
  appearanceDarkMode: "深色模式",
  promotionModalTitle: "優惠",
  promoItem: "優惠類別",
  promoCode: "優惠碼",
  discount: "折扣",
  applyBtn: "應用",
  applyPromotionErrorTips: "你的優惠碼無效",
};

export default setting;
